import { useAtomValue } from 'jotai';
import { useCallback } from 'react';

import { WHATSAPP_PREFIX } from '@/src/modules/CampaignsModule/constants';

import { atomHasInbox } from '@/modules/InboxModule/atoms/inboxAtom';

export const useInboxUtils = () => {
  const enableWhatsAppModule = useAtomValue(atomHasInbox);

  const isWhatsAppAction = useCallback(
    (actionName: string): boolean => {
      return actionName.startsWith(WHATSAPP_PREFIX) && enableWhatsAppModule;
    },
    [enableWhatsAppModule]
  );

  return {
    events: {
      isWhatsAppAction,
    },
  };
};
